import { __extends } from "tslib";
/**
 * Created by Dominika.Grabowska on 2016-06-30.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import radioTabsTemplate from '../template/radio-tabs.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
// import swiper controller to get swiper instance with modules through 'getSwiper' method
import BSSSwiperController from '../../bss-swiper-tabs-component/js/bss-swiper-controller';
import logger from '@main/externals/bss-package-logger/js/logger';
var radioTabsTemplates = {
    defaultTemplate: radioTabsTemplate,
};
/**
 * BSSRadioTabsComponent class
 */
var BSSRadioTabsComponent = /** @class */ (function (_super) {
    __extends(BSSRadioTabsComponent, _super);
    /**
     * @desc BSSRadioTabsComponent constructor - generates all necessary objects and initialize radio tabs
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     * @listens {bss-entity-created-$ENTITY-INSTANCE-ID}
     * @listens {bss-component-data-rebound-$COMPONENT-ID}
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-fonts-ready-$ENTITY-INSTANCE-ID}
     */
    function BSSRadioTabsComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, radioTabsTemplates, toolbox) || this;
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._componentVersion = '@@name ver. @@version';
        logger.info('RadioTabsComponent ' +
            _this._config.componentId +
            ' has been successful render');
        if (typeof _this._config.remoteInit === 'undefined' ||
            _this._config.remoteInit === false) {
            _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this._initRadioTabs.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        _this._eventManager.subscribe('bss-component-data-rebound-' + _this._config.componentId, _this._hideRadioTabsSwiper.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._sameXsTabsBehaviour = !!_this._config.sameXsTabsBehaviour;
        _this._isResizeEventOff = true;
        /**
         * @desc this flag is responsible for initializing swiper // Swiper by www.idangero.us
         * @type {Boolean}
         * @private
         */
        _this._isInitOnSwiper = _this._config.initOnSwiper
            ? _this._config.initOnSwiper
            : false;
        /**
         * @desc preconfiguration of swiper (with events and some important params) // Swiper by www.idangero.us
         * @type {Object}
         * @private
         */
        _this._swiperPreConfig = {
            on: {
                init: _this._updateSwiper.bind(_this),
                click: _this._slideToActiveSlide.bind(_this),
            },
            updateOnWindowResize: true,
            touchReleaseOnEdges: true,
            normalizeSlideIndex: false,
            simulateTouch: true,
            slidesPerView: 'auto',
            slideClass: 'radio-swiper-slide',
            wrapperClass: 'radio-swiper-wrapper', // important because of css conflicts with bss-swiper-tabs
        };
        _this._bindResize();
        /**
         * id of event subscriptions
         * @type {string}
         * @private
         */
        _this._subscrberId = _this.subscriberPrefix + _this._config.componentId;
        _this._eventManager.subscribe('bss-start-resize-for-' + _this._config.entityInstanceId, _this._bindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._eventManager.subscribe('bss-stop-resize-for-' + _this._config.entityInstanceId, _this._unbindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._eventManager.subscribe('bss-fonts-ready-' + _this._config.entityInstanceId, _this._updateRadioTabsSwiper.bind(_this), _this.subscriberPrefix + _this._config.componentId, true);
        _this._addSwiperDefaults();
        return _this;
    }
    /**
     * Update swiper view: set shadows and slide to active slide
     * @private
     */
    BSSRadioTabsComponent.prototype._updateSwiper = function (swiper) {
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _updateSwiper');
        var $checkedRadio = this._componentTemplate.find('.radio-swiper-slide.bss-checked');
        var activeSlideIndex = $checkedRadio.length ? $checkedRadio.index() : 0;
        this._slideToActiveSlide(swiper, null, activeSlideIndex);
    };
    /**
     * Add swiper events and variables
     * @private
     */
    BSSRadioTabsComponent.prototype._addSwiperDefaults = function () {
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _addSwiperDefaults');
        if (this._isInitOnSwiper) {
            /**
             * Swiper container jQuery element
             * @type {jQuery}
             * @private
             */
            this._$swiperContainer = this._componentScope.find('.bss-radio-switch-container');
            if (!this._config.entityReady) {
                // Prevent click on tabs until swiper recalculation is ready
                // on first time component init (when entity is not ready yet)
                this._$swiperContainer.css('pointer-events', 'none');
                this._eventManager.subscribe('bss-entity-created-' + this._config.entityInstanceId, this._initSwiperOnLoad.bind(this), this._subscrberId);
            }
            else {
                this._initSwiperOnLoad();
            }
        }
    };
    /**
     * Slide swiper to active slide
     * @param {Swiper} swiper
     * @param {Event} _ev
     * @param {number} activeSlide
     * @private
     */
    BSSRadioTabsComponent.prototype._slideToActiveSlide = function (swiper, _ev, activeSlide) {
        if (activeSlide === void 0) { activeSlide = swiper.clickedIndex; }
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _slideToActiveSlide');
        swiper.slideTo(activeSlide);
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSRadioTabsComponent.prototype._bindResize = function () {
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._resizeHandler.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSRadioTabsComponent.prototype._unbindResize = function () {
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc base destroy method
     * @override
     */
    BSSRadioTabsComponent.prototype.destroy = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * @desc initialize radio tabs component
     * @private method
     */
    BSSRadioTabsComponent.prototype._initRadioTabs = function () {
        var _this = this;
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _initRadioTabs');
        if (this.isDestroyed) {
            return;
        }
        /**
         * radio tabs swiper // OLD swiper (deprecated from 2019 toyota/lexus restyling)
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._radioSwiper = this._componentTemplate.find('.bss-radio-switch_swiper');
        /**
         * duration of radio tabs swiper animation
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._animDuration =
            typeof this._config.animDuration === 'undefined' ||
                this._config.animDuration === ''
                ? 300
                : parseInt(this._config.animDuration);
        this.resize = false;
        /**
         * All radio buttons in the radio tabs
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._radioButtons = this._componentTemplate.find('.bss-radio-switch_input');
        if (this._radioButtons.length) {
            if (this._isInitOnSwiper) {
                this._window.on('resize.' + this._config.componentId, this._toolbox._.throttle(this._toolbox._.bind(this._reinitSwiper, this), 200));
                this._window.on('orientationchange.' + this._config.componentId, function () {
                    // After orientationchange, add a one-time resize event
                    _this._toolbox.$(window).one('resize', _this._reinitSwiper.bind(_this));
                });
            }
            else {
                this._radioButtons.on('click.' + this._config.componentId, this._toolbox._.throttle(this._toolbox._.bind(this._updateRadioTabsSwiper, this), this._animDuration));
                this._radioButtons.on('update-click.' + this._config.componentId, this._toolbox._.throttle(this._toolbox._.bind(this._updateRadioTabsSwiper, this), this._animDuration));
                this._updateRadioTabsSwiper();
            }
        }
    };
    /**
     * Check if sliders width is bigger then its container
     * @returns {boolean}
     * @private
     */
    BSSRadioTabsComponent.prototype._isSwiperWidth = function () {
        var _this = this;
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _isSwiperWidth');
        var swiperWrapperWidth = this._$swiperContainer.width();
        var realSwiperWidth = 0;
        /**
         * Swiper wrapper jQuery element.
         * Wait until swiper wrapper is rendered
         * @type {jQuery}
         * @private
         */
        var $swiperSlides = this._$swiperContainer.find('.bss-radio-switch_item');
        if ($swiperSlides && $swiperSlides.length) {
            $swiperSlides.each(function (i, el) {
                realSwiperWidth += _this._toolbox.$(el).outerWidth(true);
            });
        }
        return realSwiperWidth > swiperWrapperWidth;
    };
    /**
     * @desc init swiper on entity ready
     * @private
     */
    BSSRadioTabsComponent.prototype._initSwiperOnLoad = function () {
        logger.info('RadioTabsComponent ' +
            this._config.componentId +
            ' => function : _initSwiperOnLoad');
        this._reinitSwiper();
        this._$swiperContainer.css('pointer-events', 'all');
    };
    /**
     * Create/delete swiper instance depending on components width
     * @private
     */
    BSSRadioTabsComponent.prototype._reinitSwiper = function () {
        var _this = this;
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _reinitSwiper');
        // Prevent events until swiper calculations are done
        this._$swiperContainer.css('pointer-events', 'none');
        // DOM elements are ready but we should wait when DOM render will be updated
        setTimeout(function () {
            if (_this._isSwiperWidth()) {
                if (!_this._swiper) {
                    _this._initSwiper();
                }
            }
            else if (_this._swiper) {
                _this._swiper.destroy();
                _this._swiper = null;
            }
            _this._$swiperContainer.css('pointer-events', 'all');
        }, 500);
    };
    /**
     * Create swiper
     * @private
     */
    BSSRadioTabsComponent.prototype._initSwiper = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _initSwiper');
        this._componentTemplate
            .find('.bss-radio-switch_item')
            .addClass('radio-swiper-slide');
        var swiperController = new BSSSwiperController({
            selector: "#".concat(this._config.componentId, " .swiper-container"),
            configuration: Object.assign({}, this._swiperPreConfig, this._config.radioTabsSwiperConfiguration),
        });
        this._swiper = swiperController.getSwiper();
    };
    /**
     * @desc animate radio tabs swiper // OLD swiper (deprecated from 2019 toyota/lexus restyling)
     * @private method
     */
    BSSRadioTabsComponent.prototype._updateRadioTabsSwiper = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _updateRadioTabsSwiper');
        /**
         * selected radio button
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._selectedRadioItem = this._radioButtons
            .filter(':' + 'checked')
            .siblings('.bss-radio-switch_label');
        if (this._selectedRadioItem.length !== 0) {
            this._radioSwiper.show();
            var swiperOffset = this._calcOffset(this._selectedRadioItem);
            if (this._animDuration === 0) {
                this._radioSwiper.removeAttr('style');
            }
            this._animDuration =
                typeof this._config.animDuration === 'undefined' ||
                    this._config.animDuration === ''
                    ? 300
                    : parseInt(this._config.animDuration);
            if (this.resize) {
                if (this._resolution.getCurrent() === 'xs' &&
                    !this._sameXsTabsBehaviour) {
                    this._radioSwiper.css('top', swiperOffset.top);
                    this._radioSwiper.css('height', parseInt(this._selectedRadioItem.outerHeight()) + 'px');
                }
                else {
                    this._radioSwiper.css('left', swiperOffset.left);
                    this._radioSwiper.css('width', parseInt(this._selectedRadioItem.outerWidth()) + 'px');
                }
            }
            else {
                if (this._resolution.getCurrent() === 'xs' &&
                    !this._sameXsTabsBehaviour) {
                    var swiperHeight = parseInt(this._selectedRadioItem.outerHeight()) + 'px';
                    var swiperOffsetTop = swiperOffset.top;
                    this._radioSwiper.animate({ height: swiperHeight, top: swiperOffsetTop }, this._animDuration);
                }
                else {
                    var swiperWidth = parseInt(this._selectedRadioItem.outerWidth()) + 'px';
                    var swiperOffsetLeft = swiperOffset.left;
                    this._radioSwiper.animate({ width: swiperWidth, left: swiperOffsetLeft }, this._animDuration);
                }
            }
            this.resize = false;
        }
    };
    /**
     * @desc hide radio tabs swiper if no radio is selected // OLD swiper (deprecated from 2019 toyota/lexus restyling)
     * @private method
     */
    BSSRadioTabsComponent.prototype._hideRadioTabsSwiper = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _hideRadioTabsSwiper');
        this._radioSwiper.hide();
    };
    /**
     * @desc calculate checked radio button offset (retalive to parent element)
     * @private method
     * @param {Object} obj selected radio button
     * @return {Object} childOffset top and left radio button offset
     */
    BSSRadioTabsComponent.prototype._calcOffset = function (obj) {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _calcOffset | Params: ', obj);
        var childPos = obj.offset();
        var parentPos = obj.closest('.bss-radio-switch_inner').offset();
        var childOffset = {};
        childOffset.top = childPos.top - parentPos.top;
        childOffset.left = childPos.left - parentPos.left;
        return childOffset;
    };
    /**
     * @desc fires resize handler with proper time offset
     * @private method
     */
    BSSRadioTabsComponent.prototype._resizeHandler = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _resizeHandler');
        if (!this._isInitOnSwiper) {
            if (this._resizeTimeoutDestroyer !== null) {
                clearTimeout(this._resizeTimeoutDestroyer);
            }
            this._animDuration = 0;
            this.resize = true;
            this._resizeTimeoutDestroyer = setTimeout(this._updateRadioTabsSwiper.bind(this), 100);
        }
    };
    return BSSRadioTabsComponent;
}(BSSAbstractComponent));
export default BSSRadioTabsComponent;
